import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
export function ShortTestimonials() {
  const testimonials = [{
    quote: 'Tengo todo planificado hasta diciembre. Mis domingos volvieron a ser míos.',
    author: 'M.L., Córdoba'
  }, {
    quote: 'Ya viene todo secuenciado. No tengo que pensar el orden, solo imprimir y aplicar.',
    author: 'V.R., Rosario'
  }, {
    quote: 'Las rúbricas y fichas son un lujo. Hago los informes en la mitad de tiempo.',
    author: 'S.G., CABA'
  }];
  return <section className="w-full bg-transparent py-10" data-id="element-189">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-190">
        <div className="text-center mb-6" data-id="element-191">
          <p className="text-xs uppercase tracking-[0.2em] text-[#C084FC] font-semibold mb-1" data-id="element-192">
            Lo que dicen nuestras profesionales
          </p>
          <h2 className="text-xl md:text-3xl font-bold text-white font-['Open_Sans',_sans-serif]" data-id="element-193">
            Testimonios <span className="text-[#9333EA]" data-id="element-194">reales</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-195">
          {testimonials.map((t, index) => <div key={index} className="bg-[#141414] border border-[#2A2A2A] rounded-2xl p-5 hover:border-[#C084FC]/30 transition-all duration-200 flex flex-col" data-id="element-196">
              <QuoteIcon className="w-5 h-5 text-[#C084FC]/60 mb-3" data-id="element-197" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-198">
                "{t.quote}"
              </p>
              <div className="flex items-center justify-between mt-4 pt-3 border-t border-[#2A2A2A]" data-id="element-199">
                <span className="text-[11px] font-semibold text-white" data-id="element-200">
                  {t.author}
                </span>
                <div className="flex gap-0.5 text-yellow-400" data-id="element-201">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="w-3 h-3 fill-current" data-id="element-202" />)}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}